import start from "api/start";
import partner from "api/partner";


const api = { start, partner };
export default api;